/* eslint-disable no-inline-comments */
import Vue from "vue";
import Router from "vue-router";

const GuestCount = () => import("@/views/guestCount/guestCount.vue"),
	Items = () => import("@/views/items/items.vue"),
	ServiceTimes = () => import("@/views/serviceTimes/serviceTimes.vue"),
	Overview = () => import("@/views/overview/overview.vue"),
	MainView = () => import("./views/MainView.vue"),
	Login = () => import("@/views/auth/login/Login.vue"),
	Support = () => import("@/views/support/support.vue"),
	CategoryBreakdown = () => import("@/views/categoryBreakdown/categoryBreakdown.vue"),
	Settings = () => import("@/views/settings/settings.vue"),
	MyGoals = () => import("@/views/myGoals/myGoals.vue"),
	TrackedItems = () => import("@/views/trackedItems/trackedItems.vue");

Vue.use(Router);

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior () {
		return {
			// eslint-disable-next-line id-length
			x: 0,
			// eslint-disable-next-line id-length
			y: 0
		};
	},
	routes: [

		{
			path: "/sign-in/:branding?",
			alias: [ "/forgot-password/:branding?", "/reset-password/:branding?" ],
			name: "login",
			component: Login,
			meta: {isPublic: true}
		},

		{
			path: "/",
			component: MainView,
			redirect: "/",
			children: [
				{
					path: "/",
					name: "overview",
					component: Overview,
					meta: {
						isPublic: false,
						showFilters: true
					}
				},
				{
					path: "/help",
					name: "support",
					component: Support,
					meta: {isPublic: false}
				},
				{
					path: "/category-breakdown",
					name: "category",
					component: CategoryBreakdown,
					meta: {
						isPublic: false,
						showFilters: true
					}
				},
				{
					path: "/my-goals",
					name: "myGoals",
					component: MyGoals,
					meta: {isPublic: false}
				},
				{
					path: "/tracked-items",
					name: "trackedItems",
					component: TrackedItems,
					meta: {isPublic: false}
				},
				{
					path: "/settings",
					name: "settings",
					redirect: {name: "guestCount"},
					component: Settings,
					meta: {isPublic: false},
					children: [
						{
							path: "guest-count",
							name: "guestCount",
							component: GuestCount,
						},
						{
							path: "items",
							name: "items",
							component: Items,
						},
						{
							path: "service-times",
							name: "serviceTimes",
							component: ServiceTimes,
						}
					]
				},
			]
		}
	]
});
